/* ─────────────────────────────────────────────────────────────
   Cartridge Works — v2.js
   The services shelf: drag it, swipe it, arrow it. The section
   takes the colour of whichever shell you're on.
   Loads after app.js, which still owns the panel switching.
   ───────────────────────────────────────────────────────────── */
(function () {
  "use strict";

  var rail  = document.getElementById("cart-rail");
  var stage = document.getElementById("svc-stage");
  if (!rail || !stage) return;

  var carts = Array.prototype.slice.call(rail.querySelectorAll(".cart"));
  var arrows = Array.prototype.slice.call(document.querySelectorAll("[data-rail]"));
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── colour ─────────────────────────────────────────────── */
  /* Hover paints the stage. Moving away puts it back to whatever
     is actually loaded, so the colour always tells the truth
     about which cartridge is in. */

  function tint(svc) { stage.setAttribute("data-svc-tint", svc); }
  function selected() {
    var on = rail.querySelector(".cart.active");
    return on ? on.getAttribute("data-svc") : "brand";
  }
  function restore() { tint(selected()); }

  carts.forEach(function (cart) {
    var svc = cart.getAttribute("data-svc");
    cart.addEventListener("mouseenter", function () { tint(svc); });
    cart.addEventListener("focus", function () { tint(svc); });
    cart.addEventListener("click", function () { tint(svc); });
  });
  rail.addEventListener("mouseleave", restore);
  rail.addEventListener("focusout", function (e) {
    if (!rail.contains(e.relatedTarget)) restore();
  });

  /* ── arrows ─────────────────────────────────────────────── */

  function step() {
    var cart = carts[0];
    if (!cart) return 240;
    return cart.getBoundingClientRect().width + 26;   // + the rail gap
  }

  function scrollBy(dir) {
    rail.scrollBy({ left: dir * step(), behavior: reduceMotion ? "auto" : "smooth" });
  }

  arrows.forEach(function (btn) {
    btn.addEventListener("click", function () {
      scrollBy(parseInt(btn.getAttribute("data-rail"), 10));
    });
  });

  function syncArrows() {
    var max = rail.scrollWidth - rail.clientWidth - 1;
    arrows.forEach(function (btn) {
      var dir = parseInt(btn.getAttribute("data-rail"), 10);
      btn.disabled = dir < 0 ? rail.scrollLeft <= 0 : rail.scrollLeft >= max;
    });
  }
  rail.addEventListener("scroll", syncArrows, { passive: true });
  window.addEventListener("resize", syncArrows);
  syncArrows();

  /* ── keyboard ───────────────────────────────────────────── */

  rail.addEventListener("keydown", function (e) {
    if (e.key === "ArrowRight") { e.preventDefault(); scrollBy(1); }
    if (e.key === "ArrowLeft")  { e.preventDefault(); scrollBy(-1); }
  });

  /* ── drag ───────────────────────────────────────────────── */
  /* Touch already swipes natively; this is for a mouse. We only
     call it a drag past 6px, so a click on a cartridge is still
     a click and app.js still gets it. */

  var down = false, startX = 0, startScroll = 0, moved = false;

  rail.addEventListener("pointerdown", function (e) {
    if (e.pointerType === "touch") return;
    down = true; moved = false;
    startX = e.clientX;
    startScroll = rail.scrollLeft;
  });

  rail.addEventListener("pointermove", function (e) {
    if (!down) return;
    /* The button came up somewhere we never heard about — a release
       outside the rail, or a lost event. Without this the rail keeps
       thinking it's held and drags on the next mouse-over. */
    if (e.buttons === 0) { endDrag(e); return; }
    var dx = e.clientX - startX;
    if (!moved && Math.abs(dx) < 6) return;
    if (!moved) {
      moved = true;
      rail.classList.add("is-dragging");
      rail.setPointerCapture(e.pointerId);
    }
    rail.scrollLeft = startScroll - dx;
  });

  function endDrag(e) {
    if (!down) return;
    down = false;
    if (moved) {
      rail.classList.remove("is-dragging");
      if (e && e.pointerId != null && rail.hasPointerCapture(e.pointerId)) {
        rail.releasePointerCapture(e.pointerId);
      }
      syncArrows();
    }
  }
  /* on window, not the rail: a press that never passed the 6px drag
     threshold sets no pointer capture, so releasing outside the rail
     fired pointerup somewhere else entirely and `down` stayed true */
  window.addEventListener("pointerup", endDrag);
  window.addEventListener("pointercancel", endDrag);
  window.addEventListener("blur", endDrag);
  rail.addEventListener("dragstart", function (e) { e.preventDefault(); });
})();
